import mapKnownValues from "@/utils/mapKnownValues";

// The stationID is not returned from the station credit program response, we have to derive it from the GET call
export type StationCreditProgramAPIResponse = {
  creditProgramId: string;
  creditProgramName?: string;
  stationId?: string;
  jsonData?: Record<string, string> | null;
};

export default class StationCreditProgram {
  needsToBeLinked = false;
  creditProgramId = "";
  creditProgramName = "";
  stationId = "";
  jsonData: Record<string, string> | null = null; // Record of key -> value for the associated credit program

  constructor(params: Partial<StationCreditProgram> = {}) {
    mapKnownValues(this, params);
  }

  static fromAPI(response: StationCreditProgramAPIResponse, stationId: string) {
    return new StationCreditProgram({
      ...response,
      stationId
    });
  }
}
